import { Card } from '@ui/components';
import { cn } from '@ui/utils';
import React from 'react';

export const DashboardCard = ({ ...props }: React.ComponentPropsWithoutRef<'div'>) => {
  const { children, className, ...rest } = props;

  return (
    <Card className={cn('flex flex-col w-full h-full p-4 overflow-auto', className)} {...rest}>
      {children}
    </Card>
  );
};
